export const DefaultCulture = {
    welcome: "Welcome",
    fetchedExternalContents: "Acessed external contents",
    informationPersisted: "Memory updated",
    internalFunctionCodeExecuted: "Code evaluated:",
    inferenceError: "Something was wrong in our end. Please, try again later.",
    inferenceCancelled: "The inference was cancelled.",
    tryAgain: "Try again",
    chatClientsEditEnd: "Finish editing",
    chatClientsEditStart: "Edit",
    chatClientsCreateNew: "Add new session",
    chatClientsText: "See your created chat sessions below. To create a new session, click the add new chat session button.",
    chatClientsTitle: "My chat sessions",
    addItemTitle: "Add chat session",
    addItemButtonText: "Add session",
    addItemText: "Enter the chat session key provided to you below.",
    multimodalTitle: "Add attachments to chat",
    attachmentImageTitle: "Add a image",
    attachmentImageSubText: "Attach images or photos",
    attachmentDocumentTitle: "Add a document",
    attachmentInlineDocumentTitle: "Add inline content",
    attachmentDocumentSubText: "Attach spreadsheets, Microsoft Word files or PDFs",
    failedToolCall: "Tool call failed \"{0}\":",
    successToolCall: "Tool called \"{0}\":",
    clearChatText: "Clear chat",
    aiMistakes: "This chat uses AI. Check for mistakes.",
    helloLabel: "Hello.",
    helloSubLabel: "How can I help you?",
    inputPlaceholder: "Talk to the assistant",
    sendButtonLabel: "Send",
    cancelButtonLabel: "Cancel",
    copyButtonLabel: "Copy",
    copyLinkButtonLabel: "Copy link",
    stateSearched: "Searched for \"{0}\"",
    stateSearchedMultiple: "Searched for multiple sources",
    stateAccessing: "Fetching \"{0}\"...",
    stateThinking: "Thinking about it...",
    stateThoughtFast: "Thought for some seconds",
    stateThought: "Thought for {0} seconds",
    messageConnectionClosedTitle: "Trying connection with AIVAX...",
    messageConnectionClosedSubText: `<p>
            We're trying to reconnect to the AIVAX servers.
        </p>
        <p>
            If this is taking so long, you can reload the page.
        </p>
        <div class="command-strip">
            <button class="command" onclick="window.location.reload()">
                Reload page
            </button>
            <a class="command" href="/www/web-chat-client">
                Go to home
            </a>
        </div>`,
    documentGenerated: "Document generated.",
    authDialogTitle: "Authenticate Account",
    authDialogDescription: "Enter your Login Key to access gateways associated with your account.",
    authDialogSaveButton: "Save Login Key",
    chatClientsEmpty: "No chat clients or gateways found. Add a new one!",
    goToSessionChat: "Go to session chat",
    createSessionButton: "Create Session",
    chatClientsClientTitle: "My chat clients",
    chatClientsClientText: "Click in a chat client below to start a new session.",
    authRequiredAlert: "Please authenticate your account first.",
    invalidLoginKeyWarning: "Invalid or expired Login Key. Clearing...",
    invalidChatLoginKeyAlert: "Your Login Key is not valid for this chat or has expired. Please authenticate again.",
    createSessionUrlError: "Error creating session: Chat URL not returned.",
    createSessionGenericError: "Could not create chat session. Check your connection or Login Key.",
    reasoningShowButton: "Show reasoning",
    openInNewTab: "Open in new tab"
};
